export const getDefaultRootCommonState = () => {
    return {
        /** Текущая ширина экрана */
        window: null,
        isWidget: process.env["VUE_APP_IS_WIDGET"] === "true",
        infoModal: {
            openModal: false,
            text: "",
            type: "",
        },
        showTemplateTitleModal: false,
        banksList: [],
        showUpdateInfoModal: false,
        isRu: true,
        mode: "quiz",
        eyeView: false,
        showExcludedBanksList: false,
        showDownloadModal: false,
    };
};
export const commonState = getDefaultRootCommonState();
